<mat-card class="mb-0">
  <mat-card-content>
    <div class="card-header">
      <h3 class="info-title">אירועים</h3>
      <a href="#" class="more-link">לכל האירועים</a>
    </div>

    <div class="carousel-wrap">
      <swiper-container
        pagination="true"
        pagination-clickable="true"
        [breakpoints]="breakpoints"
        class="carousel"
      >
        <swiper-slide *ngFor="let event of events">
          <app-event-item [event]="event" />
        </swiper-slide>
      </swiper-container>
    </div>
  </mat-card-content>
</mat-card>
